module.exports = __webpack_public_path__ + "static/media/storytrails-logo-58-48.725a659c.svg";